import { IAppSettings } from "../../models/settings";
import { ESetttingsActions, SettingsActions } from "../actions/boot";
import { SettingsState } from "../states/settings";

export function SettingsReducers(
  state: IAppSettings = SettingsState,
  action: SettingsActions,
): IAppSettings {
  switch (action.type) {
    case ESetttingsActions.SettingsRequest: {
      return {
        ...state,
      };
    }
    case ESetttingsActions.SettingsRequestOk: {
      return {
        ...state,
      };
    }
    case ESetttingsActions.SettingsRequestFailed: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}
